import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getRemoveOrganizationalUnitError() {
      return getState().error;
    },
    isRemoveOrganizationalUnitRequestFailure() {
      return getState().request.isFailure;
    },
    isRemoveOrganizationalUnitRequestPending() {
      return getState().request.isPending;
    },
    isRemoveOrganizationalUnitRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
